export enum VertexBufferType {
    MORTON = 0,
    VEC_2 = 1,
    VEC_3 = 2,
}
